<template>
    <div class="velocity-histogram-box">
        <div class="title-wrap">
            <p class="title body-2">{{ props.index + 1 }}. {{ bodyCompName }}</p>
            <CommChipList :chipTextList="computedChipTextList" />
        </div>
        <VelocityHistogram :data="props.data" :screenWidth="props.screenWidth" />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import VelocityHistogram from './VelocityHistogram.vue';
import { BODYCOMP_INFO_LIST } from '@common/common/const/inbodyData';
import { getBodyTypeValue } from '@common/common/utils/utils';
import type { VarianceHistogramResDto } from '@common/openapi-client/openapi';
import { CommChipList } from '@common/trend-report-common';

const props = defineProps<{
    data: VarianceHistogramResDto;
    index: number;
    screenWidth: number;
}>();

const bodyCompName = computed(() => {
    return BODYCOMP_INFO_LIST.find(item => item.id === props.data.BodyComp)?.koreanName;
});

const computedBodyType = computed(() => {
    return (bodyType: string) => {
        return getBodyTypeValue(bodyType, 'bodyTypeKoreanName', '2040');
    };
});

const computedChipTextList = computed(() => {
    const filter = props.data.FilterInfo;
    const list: string[] = [];

    if (filter?.Gender) {
        list.push(filter.Gender === 'M' ? '남성' : '여성');
    }
    if (filter?.AGE) {
        list.push(`${filter.AGE}세`);
    }
    if (filter?.BodyType) {
        list.push(computedBodyType.value(filter.BodyType));
    }

    return list;
});
</script>

<style scoped lang="scss">
.velocity-histogram-box {
    & + .velocity-histogram-box {
        margin-top: 1.8rem;
    }
}

.title-wrap {
    display: flex;
    align-items: center;
    padding-bottom: 1rem;

    .title {
        color: $grey-7;
        margin-right: 0.5rem;
    }
}
</style>
